import './agent.css';
import { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux'
import { Link, Outlet, useNavigate } from 'react-router-dom';
import NavbarAgent from './NavbarAgent';
import NavbarButtom from '../NavbarBottom';
// import Header from '../Header-item';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from 'react-toastify';

function Agent (props) {
    const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const {username,mobile,email,role} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
    useEffect(() => {
        console.log(token);
        if(!token){
            localStorage.removeItem('token')
            navigate('/agent/login', {replace: true})
        }

        if(token && role && role == 1){
          navigate('/dashboard')
        }else if(token && role && role == 3){
            navigate('/exhibition')
        }

    },[])
  return (
      <>
      {
        token ? (
          <NavbarAgent logo={props.logo} mobile={mobile} />
        ): null
      }
      <div className="main-content" >
        <Outlet context={[props.url]} />
      </div>
      <ToastContainer />
      {
        token ? (
          <NavbarButtom />
        ): null
      }
      
      </> 
  )
}

export default Agent;